<template>
  <div class="flex flex-dir-column app-layout orver-hidden-x" v-loading="queryLoading">
    <!-- 顶部搜索的表单 -->
    <div class="flex top-search">
      <el-row type="flex" class="margin-right-20">
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            页面名称：{{ $route.query.pageName }}<br />
            事件名称：{{ $route.query.eventName }}<br />
            事件标识：{{ $route.query.eventCode }}
          </div>
          <div
            class="overflow-hidden"
            style="min-width: 100px; white-space: nowrap; text-overflow: ellipsis"
          >
            <strong class="font-size-20 bold">
              {{ $route.query.pageName }}
              <template v-if="$route.query.eventName">:</template>
              {{ $route.query.eventName }}
            </strong>
            <span class="font-size-12 padding-left-10" style="color: #999">{{
              $route.query.eventCode
            }}</span>
          </div>
        </el-tooltip>
      </el-row>
      <el-form
        class="margin-left-20"
        size="small"
        ref="topForm"
        :model="topSearchData"
        label-width="80px"
        :inline="true"
      >
        <el-form-item label>
          <el-date-picker
            v-model="formQuery.range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            unlink-panels
            :clearable="false"
            @change="handleQueryData"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="系统">
          <el-select @change="osInfosChange" v-model="formQuery.os" placeholder="请选择系统">
            <el-option
              v-for="item in osInfos"
              :key="item.os"
              :label="item.os"
              :value="item.value === undefined ? item.os : item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本">
          <el-select
            @change="handleQueryData"
            v-model="formQuery.osVersion"
            placeholder="请选择版本"
            clearable
          >
            <el-option
              v-for="(item, index) in osVersions"
              :key="`osVersion-${index}`"
              :label="item.os === undefined ? item : item.os"
              :value="item.value === undefined ? item : item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="small" type="primary" @click="handleQueryData(1)">查询</el-button>
      </el-form>
    </div>
    <el-card
      class="flex-1 box-card box-card-echart"
      shadow="never"
      :body-style="{ padding: '0 20px' }"
    >
      <el-card class="box-card margin-bottom-20" shadow="never">
        <!-- 顶部各种总数据，还未传参 -->
        <totalData :data="eventCountData"></totalData>
      </el-card>
      <el-card class="box-card" shadow="never">
        <!-- 选项菜单 -->
        <el-tabs v-model="activeIndex" @tab-click="queryChartData">
          <el-tab-pane label="用户统计" name="1">
            <!-- 条件选择表单 -->
            <div class="condition-form">
              <div class="userCondition">
                <Echart
                  isMountedRender
                  ref="userConEchart"
                  :id="'userCondition'"
                  :data="chartData"
                  isMultipleX
                ></Echart>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="用户TOP统计" name="2">
            <top-form
              @change="
                (topCount) => {
                  formQuery.topCount = topCount;
                  queryChartData();
                }
              "
            ></top-form>
            <div class="userTOP">
              <Echart
                :id="'userTOP'"
                :data="chartData2"
                :xType="'value'"
                :yType="'category'"
                :xShow="false"
                showData
                :type="'bar'"
              ></Echart>
            </div>
          </el-tab-pane>
          <el-tab-pane label="应用信息统计" name="3">
            <div class="sys-pie flex">
              <div
                class="padding-right-10 sys-pie-item"
                v-for="(item, index) in chartData3"
                :key="index"
              >
                <Echart isMountedRender :type="'pie'" :data="item" :id="`userSys${index}`"></Echart>
              </div>
            </div>
            <div class="app-bar">
              <div
                class="app-bar-item"
                v-for="(item, index) in chartData4"
                :key="`chartData4_${index}`"
              >
                <div class="app-bar-title">系统版本({{ item.name }})</div>
                <Echart
                  isMountedRender
                  :type="'more'"
                  :data="item.data"
                  :id="`userSysbarAPPios_${index}`"
                ></Echart>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import Echart from '@/views/components/echart/index.vue';
import totalData from '@/views/event-manage/component/total-data/index.vue';
import topForm from '@/views/event-manage/component/top-form/index.vue';
import {
  queryEventCount,
  queryOsInfo,
  queryEventCountTendency,
  queryEventUserTop,
  queryEventOsStat,
  queryEventOsVersionTendency,
} from '@/api/event';

export default {
  components: { totalData, Echart, topForm },
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel']),
  },
  data() {
    return {
      sysBarselect: '全部系统',
      chartData: {
        legend: ['选中时间段', '对比时间段'],
        x: [
          {
            data: [0],
          },
          {
            data: [0],
          },
        ],
        y: [
          {
            name: '选中时间段',
            data: [],
          },
          {
            name: '对比时间段',
            data: [],
          },
        ],
      },
      chartData2: {
        x: ['暂无数据'],
        y: [0],
      },
      chartData3: [],
      chartData4: [],
      activeIndex: '1',
      topSearchData: {
        date: [],
        system: 'web',
        version: '',
      },
      //   各种下拉框选项列表
      systems: [
        { label: 'web', value: 'web' },
        { label: 'app', value: 'app' },
      ],
      versions: [
        { label: 'v1.0', value: '1.0' },
        { label: 'v1.0', value: '1.1' },
      ],
      browsers: [
        { label: 'v1.0', value: '1.0' },
        { label: 'v1.0', value: '1.1' },
      ],
      dateScope: [{ label: '自定义', value: '1' }],
      formQuery: {
        range: [],
        osVersion: '',
        os: '',
        topCount: 10,
      },
      osInfos: [],
      osVersions: [],
      eventCountData: [
        { name: '触发总次数', data: 0 },
        { name: '用户数(uv)', data: 0 },
      ],
      queryLoading: false,
    };
  },
  mounted() {
    const today = new Moment().format('YYYY-MM-DD');
    const today2 = new Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryOsInfo();
  },
  watch: {
    source: {
      handler() {
        this.queryOsInfo();
      },
    },
    env: {
      handler() {
        this.queryOsInfo();
      },
    },
  },
  methods: {
    async queryOsInfo() {
      this.queryLoading = true;
      try {
        const { range } = this.formQuery;
        const data = {
          analyzeTimeTo: new Moment(range[1]).format('YYYY-MM-DD'),
          analyzeTimeFrom: new Moment(range[0]).format('YYYY-MM-DD'),
        };
        const {
          data: { osInfos },
        } = await queryOsInfo(data);
        this.osInfos.splice(0, this.osInfos.length, ...[{ os: '全部', value: '' }, ...osInfos]);

        this.formQuery.os = '';
        this.osInfosChange();
        this.handleQueryData();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEventUserTop(data) {
      this.queryLoading = true;
      try {
        const { topCount } = this.formQuery;
        const {
          data: { eventUserTops },
        } = await queryEventUserTop({ ...data, topCount });

        const xList = [];
        const yList = [];
        if (!eventUserTops.length) {
          xList.push('暂无数据');
          yList.push(0);
        } else {
          eventUserTops.reverse();
          eventUserTops.forEach(({ userName, count }) => {
            xList.push(
              userName
                .split('')
                .map((item, index) => (!((index + 1) % 10) ? `${item}\n` : item))
                .join(''),
            );
            yList.push(count);
          });
        }
        this.chartData2.x.splice(0, this.chartData2.x.length, ...xList);
        this.chartData2.y.splice(0, this.chartData2.y.length, ...yList);

        // chartData2: {
        //   x: ['用户', '用户', '用户', '用户', '用户', '用户'],
        //   y: [1, 2, 3, 4, 5, 6],
        // },
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEventCountTendency(data) {
      this.queryLoading = true;
      try {
        const {
          data: { eventCounts },
        } = await queryEventCountTendency(data);
        const xList = [
          {
            data: [],
          },
          {
            data: [],
          },
        ];
        const yList = [
          {
            name: '对比时间段',
            data: [],
          },
          {
            name: '选中时间段',
            data: [],
          },
        ];
        if (!eventCounts.length) {
          const { analyzeTimeTo, analyzeTimeFrom } = data;
          const days = Moment(analyzeTimeTo).diff(Moment(analyzeTimeFrom), 'days') + 1;

          // 计算相差多少天
          for (let i = 0, len = days; i < len; i++) {
            xList[0].data.push(
              Moment(analyzeTimeFrom)
                .subtract(i, 'days')
                .format('YYYY-MM-DD'),
            );
            xList[1].data.push(
              Moment(analyzeTimeTo)
                .subtract(i, 'days')
                .format('YYYY-MM-DD'),
            );
            yList[0].data.push(0);
            yList[1].data.push(0);
          }
        } else {
          // eslint-disable-next-line object-curly-newline
          eventCounts.forEach(({ currentAnalyzeTime, referAnalyzeTime, current, refer }) => {
            xList[0].data.push(currentAnalyzeTime);
            xList[1].data.push(referAnalyzeTime);
            yList[0].data.push(refer);
            yList[1].data.push(current);
          });
        }
        this.chartData.x.splice(0, this.chartData.x.length, ...xList);
        this.chartData.y.splice(0, 2, ...yList);
        this.chartData.legend = ['选中时间段', '对比时间段'];
        // chartData: {
        //   x: [1, 2, 3, 4, 5, 6],
        //   y: [{ name: '测试1', data: [2, 3, 4, 5, 6] },
        //     { name: '测试2', data: [4, 2, 1, 9, 10] },],
        // },
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async queryEventOsStat(data) {
      this.queryLoading = true;
      try {
        const {
          data: {
            osStat: { osStatItems },
            osVersionStats,
          },
        } = await queryEventOsStat(data);

        const promiseList = [];
        const chartData4 = [];

        osStatItems.forEach(async (item, index) => {
          osStatItems[index] = {
            name: item.os,
            value: item.count,
          };
          promiseList.push(
            queryEventOsVersionTendency({
              ...data,
              os: item.os,
            }),
          );
          chartData4[index] = { name: item.os };
        });

        if (!osStatItems.length) {
          osStatItems[0] = {
            name: '暂无数据',
            value: 1,
          };
        }

        const chartData3 = [
          {
            name: `${data.os || '全部'}\n\n系统分布`,
            data: osStatItems,
          },
        ];
        osVersionStats.forEach(({ os, osVersionStatItems }) => {
          const chartItemData = [];
          osVersionStatItems.forEach(({ osVersion, count }) => {
            chartItemData.push({
              value: count,
              name: osVersion,
            });
          });
          chartData3.push({
            name: os,
            data: chartItemData,
          });
        });

        if (!osVersionStats.length) {
          chartData3.push({
            name: '暂无数据',
            data: [
              {
                value: 0,
                name: '',
              },
            ],
          });
        }

        this.chartData3.splice(0, this.chartData3.length, ...chartData3);

        const res = await Promise.all(promiseList);
        res.forEach(({ data: { osVersionTendencies, osVersions } }, resIndex) => {
          const xAxis = [];
          const series = [];
          osVersions.forEach((version) => {
            series.push({
              name: version,
              type: 'bar',
              data: [],
            });
          });

          osVersionTendencies.forEach(({ analyzeTime, osVersionCounts }) => {
            xAxis.push(analyzeTime);
            if (osVersionCounts.length) {
              osVersionCounts.forEach(({ osVersion, count }) => {
                series.some(({ name }, seriesIndex) => {
                  if (name === osVersion) {
                    series[seriesIndex].data.push(count || 0);
                    return true;
                  }
                  return false;
                });
              });
            } else {
              series.forEach((item, index) => {
                series[index].data.push(0);
              });
            }
          });
          chartData4[resIndex].data = { xAxis, series };
        });

        // console.log('chartData4chartData4', chartData4);
        if (!chartData4.length) {
          chartData4.push({
            name: '暂无数据',
            data: {
              series: [
                {
                  data: [0],
                  name: '暂无数据',
                  type: 'bar',
                },
              ],
              xAxis: [new Moment(data.analyzeTimeFrom).format('YYYY-MM-DD')],
            },
          });
        }
        this.chartData4.splice(0, this.chartData4.length, ...chartData4);
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    async handleQueryData() {
      this.queryLoading = true;
      try {
        const { eventId, eventCode } = this.$route.query;
        const { range, osVersion, os } = this.formQuery;
        const data = {
          eventId,
          eventCode,
          analyzeTimeTo: new Moment(range[1]).format('YYYY-MM-DD'),
          analyzeTimeFrom: new Moment(range[0]).format('YYYY-MM-DD'),
          osVersion,
          os,
        };
        const {
          data: { eventCount, userCount },
        } = await queryEventCount(data);
        this.eventCountData[0].data = eventCount;
        this.eventCountData[1].data = userCount;

        this.queryChartData();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    queryChartData() {
      const { eventId, eventCode } = this.$route.query;
      const { range, osVersion, os } = this.formQuery;
      const analyzeTimeTo = new Moment(range[1]).format('YYYY-MM-DD');
      const analyzeTimeFrom = new Moment(range[0]).format('YYYY-MM-DD');
      const days = new Moment(analyzeTimeTo).diff(new Moment(analyzeTimeFrom), 'days') + 1;

      const data = {
        eventId,
        eventCode,
        analyzeTimeTo,
        analyzeTimeFrom,
        referAnalyzeTime: new Moment(range[0]).subtract(days, 'days').format('YYYY-MM-DD'),
        osVersion,
        os,
        organizationIdList: [],
      };
      switch (this.activeIndex) {
        case '1':
          this.queryEventCountTendency(data);
          break;
        case '2':
          this.queryEventUserTop(data);
          break;
        case '3':
          this.queryEventOsStat(data);
          break;
        default:
          break;
      }
    },
    osInfosChange() {
      const filterData = this.osInfos.filter((item) => item.os === this.formQuery.os);

      const [{ osVersions = [] }] = filterData.length ? filterData : [{ osVersions: [] }];

      this.formQuery.osVersion = '';
      this.osVersions.splice(
        0,
        this.osVersions.length,
        ...[{ os: '全部', value: '' }, ...osVersions],
      );

      this.handleQueryData();
    },
  },
};
</script>
<style lang="scss" scoped>
.app-layout {
  height: calc(100vh - 0);
  min-width: 800px;
  margin: 15px 0 0;
}
.top-search {
  // position: fixed;
  // top: 90px;
  text-align: left;
  background: #fff;
  // min-width: 1200px;
  padding-top: 20px;
  padding-left: 20px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  z-index: 10;
}
.box-card {
  &-echart {
    margin-bottom: 20px;
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.sys-bar {
  margin-top: 30px;
  text-align: left;
}
.app-bar {
  margin-top: 50px;
}
.app-bar-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin: 20px 0 10px;
}
.sys-pie {
  flex-wrap: wrap;
}
.sys-pie-item {
  width: 33%;
  min-width: 200px;
}
</style>
